import axios from 'axios';

// 業者専用のaxiosインスタンス。顧客側 api.js とトークン保管キーを分けることで、
// 同一ブラウザで顧客・業者を同時ログインしても Authorization ヘッダーが衝突しない。
const contractorApi = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8001/api/',
    headers: { 'Content-Type': 'application/json' },
});

contractorApi.interceptors.request.use((config) => {
    const token = localStorage.getItem('contractor_access_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    if (config.url) config.url = config.url.replace(/\/+$/, '');
    // FormData を送る場合は Content-Type を削除して axios/ブラウザに自動設定させる
    if (config.data instanceof FormData) {
        delete config.headers['Content-Type'];
    }
    return config;
});

contractorApi.interceptors.response.use(
    (res) => res,
    (error) => {
        if (
            (error.response?.status === 401 || error.response?.status === 403)
            && !window.location.pathname.startsWith('/contractor/login')
        ) {
            localStorage.removeItem('contractor_access_token');
            localStorage.removeItem('contractor_id');
            localStorage.removeItem('company_name');
            window.location.href = '/contractor/login';
        }
        return Promise.reject(error);
    }
);

export default contractorApi;
